import { z } from "zod";
import { journeyScreenSchema } from "./journey-event.js";
import { customerOperationsEventIdSchema, customerOperationsOpaqueIdSchema, } from "./customer-operations-core.js";
import { customerOperationsEventTypeSchema, } from "./customer-operations-events.js";
z.config({ jitless: true });
export const customerActivitySchemaVersionSchema = z.literal("2026-09-29.1");
export const customerActivityEventTypes = [
    "APP_PROFILE_CREATED",
    "APP_SESSION_ESTABLISHED",
    "CLIENT_SIGN_OUT_SELECTED",
    "VOUCHER_REDEMPTION_ACCEPTED",
    "VOUCHER_REDEMPTION_REJECTED",
    "BOOK_CLAIMED",
    "BOOK_CREATED",
    "STUDIO_SESSION_STARTED",
    "GENERATION_REQUESTED",
    "GENERATION_COMPLETED",
    "GENERATION_STAGE_FAILED",
    "APPROVAL_GRANTED",
    "EXPORT_READY",
    "EXPORT_FAILED",
    "PRINT_AUTHORIZATION_GRANTED",
    "PROVIDER_ORDER_SUBMISSION_ACCEPTED",
    "SHIPMENT_STATUS_CONFIRMED",
    "DELIVERY_STATUS_CONFIRMED",
    "FULFILLMENT_EXCEPTION_CONFIRMED",
];
export const customerActivityEventTypeSchema = z.enum(customerActivityEventTypes);
export const customerActivityMetricNames = [
    "activeCustomers",
    "profilesCreated",
    "sessionsEstablished",
    "signOutsSelected",
    "voucherRedemptionsAccepted",
    "voucherRedemptionsRejected",
    "booksClaimed",
    "booksCreated",
    "studioSessionsStarted",
    "generationsRequested",
    "generationsCompleted",
    "generationFailures",
    "approvalsGranted",
    "exportsReady",
    "exportFailures",
    "printAuthorizations",
    "providerOrdersSubmitted",
    "shipmentsConfirmed",
    "deliveriesConfirmed",
    "fulfillmentExceptions",
];
export const customerActivityMetricByEventType = Object.freeze({
    APP_PROFILE_CREATED: "profilesCreated",
    APP_SESSION_ESTABLISHED: "sessionsEstablished",
    CLIENT_SIGN_OUT_SELECTED: "signOutsSelected",
    VOUCHER_REDEMPTION_ACCEPTED: "voucherRedemptionsAccepted",
    VOUCHER_REDEMPTION_REJECTED: "voucherRedemptionsRejected",
    BOOK_CLAIMED: "booksClaimed",
    BOOK_CREATED: "booksCreated",
    STUDIO_SESSION_STARTED: "studioSessionsStarted",
    GENERATION_REQUESTED: "generationsRequested",
    GENERATION_COMPLETED: "generationsCompleted",
    GENERATION_STAGE_FAILED: "generationFailures",
    APPROVAL_GRANTED: "approvalsGranted",
    EXPORT_READY: "exportsReady",
    EXPORT_FAILED: "exportFailures",
    PRINT_AUTHORIZATION_GRANTED: "printAuthorizations",
    PROVIDER_ORDER_SUBMISSION_ACCEPTED: "providerOrdersSubmitted",
    SHIPMENT_STATUS_CONFIRMED: "shipmentsConfirmed",
    DELIVERY_STATUS_CONFIRMED: "deliveriesConfirmed",
    FULFILLMENT_EXCEPTION_CONFIRMED: "fulfillmentExceptions",
});
export const clientErrorCodeSchema = z.enum([
    "RENDER_FAILED",
    "CHUNK_LOAD_FAILED",
    "UNHANDLED_ERROR",
    "UNHANDLED_REJECTION",
]);
export const customerActivityObservationCommandSchema = z.discriminatedUnion("eventType", [
    z
        .object({
        eventId: customerOperationsEventIdSchema,
        eventType: z.literal("APP_SESSION_ESTABLISHED"),
    })
        .strict(),
    z
        .object({
        eventId: customerOperationsEventIdSchema,
        eventType: z.literal("CLIENT_SIGN_OUT_SELECTED"),
    })
        .strict(),
    z
        .object({
        eventId: customerOperationsEventIdSchema,
        eventType: z.literal("STUDIO_SESSION_STARTED"),
        bookId: customerOperationsOpaqueIdSchema,
    })
        .strict(),
    // A page that failed in the customer's browser (pilot watch, 2026-10-17): a code and the
    // screen it was on, never the error's message or stack.
    z
        .object({
        eventId: customerOperationsEventIdSchema,
        eventType: z.literal("CLIENT_ERROR"),
        code: clientErrorCodeSchema,
        screen: journeyScreenSchema,
    })
        .strict(),
]);
export const customerActivityObservationResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: customerActivitySchemaVersionSchema,
        eventId: customerOperationsEventIdSchema,
        accepted: z.boolean(),
    })
        .strict(),
})
    .strict();
export const parseCustomerActivityEventType = (value) => {
    const eventType = customerOperationsEventTypeSchema.parse(value);
    return customerActivityEventTypeSchema.parse(eventType);
};
//# sourceMappingURL=customer-activity.js.map